module.exports = __webpack_public_path__ + "assets/images/China Mobile.6f1a96dcc65e911f9f3df60c442d9ccd.png";